import { render, staticRenderFns } from "./Elselect.vue?vue&type=template&id=4242ad98&scoped=true&"
import script from "./Elselect.vue?vue&type=script&lang=js&"
export * from "./Elselect.vue?vue&type=script&lang=js&"
import style0 from "./Elselect.vue?vue&type=style&index=0&id=4242ad98&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4242ad98",
  null
  
)

export default component.exports